module.exports = __webpack_public_path__ + "static/ogunnaike-e15c9f00dcc847ecb9dd05c91d282d7a.jpg";